import { memo, useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { apiPost } from '../lib/api';
import { Sidebar } from './Sidebar';

export const AdminLayout = memo(function AdminLayout() {
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      await apiPost('/auth/logout');
    } catch {
      // 即使請求失敗也清除本地狀態
    }
    navigate('/admin/login', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-brand-cream">
      <Sidebar onLogout={handleLogout} />

      {/* 主要內容區域 */}
      <main className="ml-64 min-h-screen">
        <div className="p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
});
